import { makeStyles } from 'tss-react/mui';

export const useSharedStyles = makeStyles()(theme => ({
  progressSummaryStepWithChip: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    padding: theme.spacing(2, 3),
  },
  link: {
    color: theme.palette.text.primary,
    fontSize: '14px',
    lineHeight: '143%',
    letterSpacing: '0.15px',
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:visited': {
      color: theme.palette.text.primary,
    },
    '&:hover': {
      color: theme.palette.text.primary,
    }
  },
  actionItemSubtitle: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(-1),
  }
}));
